(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lynae-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',event=>{const section=event.target.closest('.lynae-product');if(!section)return;const thumb=event.target.closest('[data-gallery-thumb]');if(thumb){const hero=section.querySelector('[data-gallery-stage] img');if(hero){hero.src=thumb.dataset.imageUrl;hero.removeAttribute('srcset')}section.querySelectorAll('[data-gallery-thumb]').forEach(item=>item.classList.toggle('is-active',item===thumb));return}const input=section.querySelector('input[name="quantity"]');if(!input)return;if(event.target.closest('[data-quantity-minus]'))input.value=Math.max(1,Number(input.value||1)-1);if(event.target.closest('[data-quantity-plus]'))input.value=Number(input.value||1)+1});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
